import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectCategoriesComponent } from './select-categories.component';
import { ClickOutsiteModule } from '../../directives/click-outsite/click-outsite.module';
import { IconModule } from '../icon/icon.module';



@NgModule({
  imports: [
    CommonModule,
    ClickOutsiteModule,
    IconModule
  ],
  declarations: [SelectCategoriesComponent],
  exports: [SelectCategoriesComponent]
})
export class SelectCategoriesModule { }
